import { createSelector } from 'reselect';

import { initialState, ScorecardRequiredModalState } from './reducer';

const selectScorecardRequiredModal = (state: {
  scorecardRequiredModal?: ScorecardRequiredModalState;
}): ScorecardRequiredModalState => state.scorecardRequiredModal || initialState;

export const makeSelectScorecardRequiredNotice = () =>
  createSelector(selectScorecardRequiredModal, substate => substate.notice);

export const makeSelectScorecardRequirement = () =>
  createSelector(
    selectScorecardRequiredModal,
    substate => substate.requirement,
  );
